/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TransactionIdInput/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function TransactionIdInput({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsPostPayment/Content/Content/Content/PaymentMethods/CreditCardManualPayment/TransactionIdInput",
  onChange,
  isInvalid,
  isSubmitting
  
}) {
let paymentsPostPaymentCreditCardManualTransactionIdValueData = fromData.useDataValue({ viewPath,
context: 'payments_post_payment',
path: 'credit_card_manual.transaction_id',
})
let paymentsPostPaymentCreditCardManualTransactionIdIsValidData = fromData.useDataIsValid({ viewPath,
context: 'payments_post_payment',
path: 'credit_card_manual.transaction_id',
validate: fromValidate.textInput,
required: true,
})
let paymentsPostPaymentCreditCardManualTransactionIdChangeData = fromData.useDataChange({ viewPath,
context: 'payments_post_payment',
path: 'credit_card_manual.transaction_id',
})
let paymentsPostPaymentIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'payments_post_payment',
})
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 marginTop={0}
 data="payments_post_payment.credit_card_manual.transaction_id"
 validate="/Data/validate.js textInput"
 required={true}
 value={paymentsPostPaymentCreditCardManualTransactionIdValueData}
 onChange={paymentsPostPaymentCreditCardManualTransactionIdChangeData}
 invalid={!paymentsPostPaymentCreditCardManualTransactionIdIsValidData}
 data="payments_post_payment"
 disabled={paymentsPostPaymentIsSubmittingData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Transaction ID"
 weight="medium"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
 backgroundColor="white"
 borderColor={dtColorsNeutral300}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}